import { Component, OnInit, Input } from '@angular/core';
import { FormControl, AbstractControl, FormGroup } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss']
})
export class FormInputComponent implements OnInit {

  @Input() inputControlName: string;
  @Input() inputControl: AbstractControl;
  @Input() type: string;
  @Input() required = true;

  @Input() formGroup: FormGroup;
  @Input() formResponse: FormResponse;

  constructor() { }

  ngOnInit(): void {
  }

}
